import { Metric } from '@/lib/system-of-units-constants'
import * as Types from '../mutation-types'
import connectManagerClient from '@/lib/connect-client/connect-manager-client'

const state = {
  systemOfUnits: Metric,
}
const getters = {
  systemOfUnits: state => state.systemOfUnits,
}
const mutations = {
  [Types.SET_SYSTEM_OF_UNITS](state, systemOfUnits) {
    let sou = systemOfUnits
    if (!systemOfUnits) {
      sou = Metric
    }
    state.systemOfUnits = sou
  },
}
const actions = {
  setSystemOfUnits({ commit }, systemOfUnits) {
    connectManagerClient
      .updateSystemOfUnits(systemOfUnits)
      .then(response => {
        commit(Types.SET_SYSTEM_OF_UNITS, systemOfUnits)
      })
      .catch(error => {
        console.error(error)
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
